//import { useState, useEffect } from 'react';

//import { firestoreMethods } from '../firebase/firestoreMethods';
//import { utilMethods } from '../utils/utilMethods';

import { Link } from "react-router-dom";



function TestHome() {

  return (
    <>
      <div className='outer-box'>
        <div className='title'>
          Test Home
        </div>
        <div className='form-button-group'>
          <Link 
            to="/test/address" 
            className='form-button primary'
          >address
          </Link> 
        </div>
      </div>
    </>
  );
}

export default TestHome;
